module.exports = __webpack_public_path__ + "media/images/landing_page/pakalpojumu_sniedzeji-b3f9dcaf360cd94d391635c808b5034c.webp";